import React, { useContext } from 'react';
import { Input } from '@riac/design-system';
import { ControlledWLItem } from 'src/components/Wishlists/WishlistItem';
import { BoxButton } from '@riac/design-system';
import {
  CatalogWishlistsSelect,
} from 'src/pages/CatalogPage/components/AuctionItems/AuctionItem/AuctionItemActions/CatalogWishlists/CatalogWishlists.style';
import { Item } from '@react-stately/collections';
import { FaPlus } from 'react-icons/fa';
import { WishlistActionContext } from 'src/lib/WishlistActionContext';
import styled from 'styled-components';
import { CatalogContext } from 'src/pages/CatalogPage/CatalogPage';

const ManageWishlistLink = styled.a`
  float: right;
  color: ${({ theme }) => theme.black[50]};
`;

const SaveButton = styled(BoxButton)``;

export const AddToWishlist = ({
  item,
  selectedList,
  wishlistSelect,
  addNew,
  saveItem,
  newItemNote,
  setNewItemNote,
  newListName,
  setNewListName,
  error,
}):JSX.Element => {
  const { currentWishlists } = useContext(WishlistActionContext);

  return (
    <>
      <p>Select a Wishlist to add the item to, or create a new wishlist.</p>
      <CatalogWishlistsSelect
        label = ''
        aria-label = 'Add to Wishlist'
        placeholder = 'Add To Wishlist'
        onChange = {(value:number):void => {
          wishlistSelect(value.toString());
        }}
        value = {selectedList}
        inverted = {true}
        noMargin
        noOptionsBorder
      >

        {currentWishlists?.map((wl) => (
          <Item key = {wl.WishListID}>{wl.WishListName}</Item>
        )).concat([(
          <Item key = '-1' textValue = 'New Wishlist'>
            <><FaPlus/> New Wishlist</>
          </Item>
        )])}

      </CatalogWishlistsSelect>
      {addNew && <>
        <h4>New Wishlist</h4>
        <Input
          type='text'
          aria-label='Wishlist Name'
          placeholder='Enter Wishlist Name'
          value={newListName}
          onChange={(value:string) => setNewListName(value)}
          error={error}
          inverted
          theRef={undefined}
        />
      </>}
      <div>
        <ControlledWLItem
          notes={newItemNote}
          setNotes={setNewItemNote}
          item={item}
          notesOpen={true}
          type='add'
        />
      </div>
      <div>
        <SaveButton onPress={saveItem} isDisabled={selectedList === '0'}>
          Save
        </SaveButton>
        <ManageWishlistLink href={'/account/wishlist'}>Manage Wishlists</ManageWishlistLink>
      </div>
    </>
  );
};
